// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.apply-error__confirmation-error {\n  color: #646d8c;\n  color: var(--color-primary);\n}\n", ""]);
// Exports
module.exports = exports;
